import React, { ChangeEventHandler, FocusEventHandler, useEffect, useState } from 'react';
import { Button, Input, Label } from 'edozvola-frontend-lib/dist/ui';
import { fetchLegalEntity, fetchPersonEntity } from 'app/shared/oib/service/oib.service';
import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';

export interface IOibInputProps {
  value: string;
  handleBlur: FocusEventHandler<HTMLInputElement>;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  errors: any;
  touched: any;
  onOibFetched?: (data: PersonModel | LegalEntityModel) => void;
  disabled?: boolean;
  fetchLegalEntity?: boolean;
}

const OibInput = (props: IOibInputProps) => {
  const [fetchButtonDisabled, setFetchButtonDisabled] = useState(true);

  useEffect(() => {
    setFetchButtonDisabled(props.errors?.oib);
  }, [props.errors?.oib, props.value]);

  const fetchOibData = () => {
    if (props.onOibFetched) {
      if (props.fetchLegalEntity) {
        fetchLegalEntity(props.value).then(legal => props.onOibFetched(legal));
      } else {
        fetchPersonEntity(props.value).then(person => props.onOibFetched(person));
      }
      setFetchButtonDisabled(true);
    } else {
      fetchPersonEntity(props.value);
    }
  };

  return (
    <>
      <Label labelText="OIB" />
      <div className="d-flex gap-1">
        <Input
          value={props.value}
          id="oib"
          name="oib"
          maxLength={11}
          disabled={props.disabled}
          onBlur={props.handleBlur}
          onChange={props.handleChange}
          error={props.errors?.oib && props.touched?.oib ? props.errors?.oib : ''}
        />
        <div>
          <Button
            size="lg"
            label={'Dohvati'}
            disabled={!props.touched?.oib || props?.disabled || fetchButtonDisabled}
            color={'info'}
            onClick={fetchOibData}
          />
        </div>
      </div>
    </>
  );
};

export default OibInput;
